import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
const stats = [{
  label: 'New Properties',
  value: '1,245',
  trend: 'up',
  change: '5.2%'
}, {
  label: 'Sold Properties',
  value: '982',
  trend: 'up',
  change: '2.1%'
}, {
  label: 'Active Properties',
  value: '3,410',
  trend: 'down',
  change: '1.4%'
}, {
  label: 'Avg. List Price',
  value: '$745k',
  trend: 'up',
  change: '4.8%'
}];
export function MarketData() {
  return <section className="py-20 md:py-24 bg-brand-cream border-y border-brand-taupe/10" data-id="element-139">
      <div className="container mx-auto px-4 md:px-6" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-142">
            Front Range market, at a glance
          </h2>
          <p className="text-brand-taupe text-sm" data-id="element-143">
            Data reflects the most recent monthly period for the north Denver
            metro.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16" data-id="element-144">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-145">
              <div className="inline-block relative mb-4" data-id="element-146">
                <div className="text-4xl md:text-5xl font-serif text-brand-charcoal" data-id="element-147">
                  {stat.value}
                </div>
                <div className="absolute -bottom-2 left-0 w-full h-[2px] bg-brand-copper" data-id="element-148"></div>
              </div>
              <div className="text-brand-taupe font-medium mb-2" data-id="element-149">
                {stat.label}
              </div>
              <div className={`flex items-center justify-center gap-1 text-sm font-medium ${stat.trend === 'up' ? 'text-green-600' : 'text-red-500'}`} data-id="element-150">
                {stat.trend === 'up' ? <TrendingUp size={16} data-id="element-151" /> : <TrendingDown size={16} data-id="element-152" />}
                {stat.change}
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-153">
          <button className="bg-brand-copper hover:bg-brand-copper/90 text-white px-8 py-4 rounded-lg font-medium transition-colors" data-id="element-154">
            Subscribe to Market Insights
          </button>
        </div>
      </div>
    </section>;
}